import styled from "styled-components";
import { responsiveWidth } from "responsive";

interface CollapseWrapperProps {
  isExpanded: boolean;
}

export const Wrapper = styled.div`
  background-color: #fbfbfb;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
`;

export const Container = styled.div`
  ${responsiveWidth}

  @media (min-width: 568px) and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 60px;

    .footer-title {
      font-family: NanumSquareOTF;
      font-weight: 700;
      font-size: 22px;
      line-height: 100%;
      letter-spacing: -5%;
      padding-top: 60px;
      display: flex;
      flex-direction: row;
      gap: 5px;
      text-align: center;

      .expand-button {
        background: #fbfbfb;
      }
    }

    .step1 {
      width: 100%;
      margin-top: 30px;
    }

    .step2 {
      width: 100%;
      margin-top: 60px;
    }
  }

  @media (max-width: 567px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 50px;

    .footer-title {
      font-family: NanumSquareOTF;
      font-weight: 700;
      font-size: 22px;
      line-height: 100%;
      letter-spacing: -5%;
      padding-top: 50px;
      display: flex;
      flex-direction: row;
      gap: 5px;
      text-align: center;

      .expand-button {
        background: #fbfbfb;
      }
    }

    .step1 {
      margin-top: 20px;
    }

    .step2 {
      margin-top: 30px;
    }
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: row;

  @media (min-width: 568px) and (max-width: 767px) {
    gap: 30px;
    font-family: NanumSquareOTF;
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: -5%;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    .value {
      font-weight: 400;
    }
  }

  @media (max-width: 567px) {
    gap: 20px;
    font-family: NanumSquareOTF;
    font-weight: 700;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: -5%;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    .value {
      font-weight: 400;
    }
  }
`;

export const SubBox = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 568px) and (max-width: 767px) {
    gap: 14px;
    margin-top: 26px;
    font-family: NanumSquareOTF;
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: -5%;
    text-align: left;

    .item {
      display: flex;
      flex-direction: row;
      gap: 5px;

      .value {
        font-weight: 400;
      }
    }
  }

  @media (max-width: 567px) {
    gap: 14px;
    margin-top: 20px;
    font-family: NanumSquareOTF;
    font-weight: 700;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: -5%;
    text-align: left;

    .item {
      display: flex;
      flex-direction: row;
      gap: 5px;

      .value {
        font-weight: 400;
      }
    }
  }
`;

export const Title = styled.div`
  @media (min-width: 568px) and (max-width: 767px) {
    font-family: NanumSquareOTF;
    font-weight: 700;
    font-size: 22px;
    line-height: 100%;
    letter-spacing: -5%;
    margin-top: 60px;
    margin-bottom: 30px;
  }

  @media (max-width: 567px) {
    font-family: NanumSquareOTF;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -5%;
    margin-top: 30px;
    margin-bottom: 20px;
  }
`;

export const ContainerTerm = styled.div`
  ${responsiveWidth}
  width: 100%;
  background: #c7c7c7;
  margin: 0 auto;
  font-size: 8.86px;
  font-weight: 400;
  line-height: 6.51px;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  @media (min-width: 568px) and (max-width: 767px) {
    .sns {
      padding: 28px 0px;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      gap: 15px;

      img {
        width: 37px;
        height: 37px;
      }
    }

    .container-term-list {
      display: flex;
      flex-direction: column;
      gap: 14px;
      padding-bottom: 35px;

      .item {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        gap: 12px;

        .term {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 12px;
          white-space: nowrap;
          font-weight: 400;
          font-size: 14.1px;
          line-height: 10.35px;
          letter-spacing: -5%;
        }
      }

      .right {
        font-weight: 400;
        font-size: 14.1px;
        line-height: 10.35px;
        letter-spacing: -5%;
      }
    }
  }

    @media (max-width: 567px) {
      .sns {
        padding-top: 28px;
        padding-bottom: 13px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        gap: 11px;

        img {
          width: 28px;
          height: 28px;
        }
      }

      .container-term-list {
        display: flex;
        flex-direction: column;
        gap: 7.98px;
        padding-bottom: 28px;

        .item {
          display: flex;
          flex-wrap: wrap;
          flex-direction: row;
          gap: 7.98px;

          .term {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 7.98px;
            white-space: nowrap;
            font-weight: 400;
            font-size: 8.86px;
            line-height: 6.51px;
            letter-spacing: -5%;
          }
        }

        .right {
          font-weight: 400;
          font-size: 8.86px;
          line-height: 6.51px;
          letter-spacing: -5%;
        }
      }
    }
  }
`;

export const CollapseWrapper = styled.div<CollapseWrapperProps>`
  max-height: ${(props) => (props.isExpanded ? "674px" : "0px")};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
`;
